/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('ConfirmRegistration.title')}}</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container" >

        <div class='mc-encart'>
          <p>{{ $t('ConfirmRegistration.register-almost-done')}}</p>
          <p>{{ $t('ConfirmRegistration.mail-sent')}}</p>
          <p>{{ $t('ConfirmRegistration.copy')}}</p>
        </div>
        <ion-item>
          <ion-label position="stacked">{{$t('ConfirmRegistration.my-code')}} *</ion-label>
          <ion-input
            type="text"
            name="validatedDateToken"
            :value="validatedDateToken"
            @input="validatedDateToken = $event.target.value"
            v-bind:placeholder="$t('ConfirmRegistration.paste')"
          ></ion-input>
        </ion-item>
        <div v-if="v$.validatedDateToken.$error">
          <div class="mc-error-label"  v-if="v$.validatedDateToken.required.$invalid">{{$t('Validation.required')}}</div>
        </div>

        <br />
        <ion-button
          type="button" class='mc-small-button' color="success" expand="block"
          v-on:click="validateEmail"
        >
          <span v-if="this.$store.state.registerStore.statusValidateToken == 'loading'">
            <ion-icon size="large" class="rotating" name="sync"></ion-icon>
          </span>
          <span v-if="this.$store.state.registerStore.statusValidateToken != 'loading'">
            {{$t('ConfirmRegistration.confirm')}}
          </span>

        </ion-button>

      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
  .mc-encart {
    border: 1px solid var(--ion-color-primary);
    border-radius: 15px;
    padding: 10px 15px;
    margin-bottom: 20px;
  }
</style>

<script>
  import {toast} from "../../Shared/Mixin/toast.mixin";
  import { required} from '@vuelidate/validators'
  import {jwtDecode} from "jwt-decode";
  import {isPlatform} from "@ionic/core";
  import {
    Plugins,
    PushNotification,
    PushNotificationToken,
    PushNotificationActionPerformed } from '@capacitor/core';
  import useVuelidate from "@vuelidate/core";

  const { PushNotifications } = Plugins;

  export default {
    name: 'confirm-registration',
    setup () {
      return { v$: useVuelidate() }
    },
    data () {
      return {
        validatedDateToken: '',
        showPublish: JSON.parse(process.env.VUE_APP_REGISTER_PUBLISH),
        loading: null
      }
    },
    mixins: [toast],
    created() {
      if (this.$route.query.token) {
        this.validatedDateToken = this.$route.query.token;
      }
    },
    watch: {
      $route(to, from) {
        setTimeout(() => {
          if (this.$route.query.token) {
            this.validatedDateToken = this.$route.query.token;
          }
        });
      }
    },
    validations() { return {
      validatedDateToken: {
        required
      }
    }},
    methods: {
      validateEmail() {
        this.v$.$reset();
        this.v$.$touch();
        if (!this.v$.$invalid) {
            const email = this.$route.params.email;
            this.$store.dispatch('validateToken', {
              email: email,
              emailToken: this.validatedDateToken
            }).then(res => {
              // this.presentToast(this.$t("ConfirmRegistration.success"), 'success');
              //this.$router.back()
              this.getUser(res);
            }).catch(() => {
              this.presentToast(this.$t("Commons.error"), 'danger')
            })
        }
      },
      async presentLoading() {
        this.loading = await this.$ionic.loadingController.create({
          message: 'Chargement',
        });
        await this.loading.present();
      },
      getUser(res) {
        if (this.loading) {
          this.loading.dismiss();
          this.loading = null;
        }
        const idUser = jwtDecode(res.data.token).id;
        this.$store.dispatch('getUser', { idUser })
          .then(res => {
            if(res.data && res.data.needParentalConsent) {
              const buttons = [{
                text: 'Réessayer',
                handler: () => {
                  this.presentLoading()
                  this.getUser(res)
                },
              }];

              alertController
                .create({
                  header: 'Autorisation parentale',
                  backdropDismiss: false,
                  cssClass: 'legal-alert',
                  message: 'L’autorisation parentale n’a pas encore été donnée par ton responsable légal dont l’adresse email que tu as communiquée est : ' + res.data.legalGuardianEmail + '. Si cette adresse email est incorrecte, tu peux nous contacter via ce formulaire <a href="https://www.mobicoop.fr/contact" target="_blank">https://www.mobicoop.fr/contact</a>.<br><br>  Dès que ton responsable légal aura donné son autorisation, tu pourras te connecter et utiliser le service ! À bientôt !',
                  buttons: buttons,
                })
                .then(a => a.present())
            } else {
              this.presentToast("Vous êtes connecté", 'success');

              if (!! this.$store.getters.redirectionUrl) {
                this.$router.replace({name: this.$store.getters.redirectionUrl.name, params: this.$store.getters.redirectionUrl.params});
                this.$store.commit('redirectionUrl_reset');
              } else {
                this.$router.push({ name: "hitchHiking.home" });
              }

              if(isPlatform(window.document.defaultView, "capacitor")) {
                PushNotifications.requestPermission().then(result => {
                  if (result.granted) {
                    // Register with Apple / Google to receive push via APNS/FCM
                    PushNotifications.register();
                  } else {
                    // Show some error
                  }
                });
              }
            }


          })
          .catch(err => {
            this.presentToast("Une erreur est survenue", 'danger')
          })
      },
    }
  }
</script>
